import type { PropsWithChildren } from 'react';
import { useCallback } from 'react';
import { useSupportLauncherId } from '@frameio/jarvis';
import { useTrackIntercomOpened } from '@frameio/plan-management/account-lock/hooks/useTrackIntercomOpened';
import TEXT from './generated/TEXT/AlertBannerSupportButton';
import { StyledButton } from './StyledButton';

TEXT.DEFINE({
  /** Aria label for support button that opens Intercom or Jarvis */
  support: 'Support',
});

export function SupportButton({ children }: PropsWithChildren) {
  const launcherId = useSupportLauncherId();
  const trackIntercomOpened = useTrackIntercomOpened();

  const handleClick = useCallback(() => {
    trackIntercomOpened();
  }, [trackIntercomOpened]);

  return (
    <StyledButton
      aria-label={TEXT.support}
      id={launcherId}
      onClick={handleClick}
      variant="body"
    >
      {children}
    </StyledButton>
  );
}
